import { useState } from 'react';
import sideKefu from "../../assets/images/sidekefu.png"
import style from "./SideKefu.module.css"
export default function Main() {
  const [showKefu, setShowKefu] = useState(false);

  return (
    <>
      <div className={`${style.kefu} ${showKefu ? style.show : "hide"}`} >
      <img src={sideKefu}  onClick={() => {
          setShowKefu(!showKefu)
      }} />
      <div>
        <h5>热线电话</h5>
        <p>0577-88927182</p>
        <p>13616621994</p>

        <h5>工作时间</h5>
        <p>周一至周五（9:00-17:00)</p>

        <h5>QQ</h5>
        <p>371617000@qq.com</p>


      </div>
      </div>
     
    </>
  )
}